import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";

import Api from "lib/api/httpRequestHelper";

import CircleIcon from "@mui/icons-material/Circle";
import CloseIcon from "@mui/icons-material/Close";
import GroupsIcon from "@mui/icons-material/Groups";
import LoadingData from "components/Loading/LoadingData";
import Scrollbar from "components/Scrollbar/Scrollbar";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";

export default function UsersCard({ storeId, setOpenedModal, setType }) {
  const [searching, setSearching] = useState(false);
  const [users, setUsers] = useState([]);
  const snackbar = useSnackbar();

  const history = useHistory();

  const verifyProfiles = JSON.parse(localStorage.getItem("userProfiles"));
  const verifyProfilesVision = JSON.parse(
    localStorage.getItem("userProfilesVision")
  );

  const userProfiles = verifyProfilesVision
    ? verifyProfilesVision
    : verifyProfiles;

  const isAdmin = userProfiles.find((profile) =>
    ["ADM", "CRC"].includes(profile.NomePerfil)
  );

  const handleSearch = async () => {
    setSearching(true);
    try {
      const response = await Api.get(
        "store-user",
        "store",
        "?idPessoaLoja=" + storeId,
        true
      );

      const perfisPermitidos = [
        "LOJA_MM",
        "LOJA_ADM_MM",
        "REPRESENTANTE_ADM",
        "REPRESENTANTE",
      ];

      const usuariosFiltrados = response.Result.ListUsuarios.filter((usuario) =>
        usuario.Perfis.some((perfil) => perfisPermitidos.includes(perfil.Nome))
      );

      setUsers(usuariosFiltrados);
    } catch (error) {
      snackbar.showMessage("Erro ao buscar informações de usuários:", {
        severity: "error",
      });
    } finally {
      setSearching(false);
    }
  };

  useEffect(() => {
    handleSearch();
  }, []);

  return (
    <Dialog open onClose={() => setOpenedModal(null)} maxWidth={"xl"} fullWidth>
      <DialogTitle>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h3" color="primary">
            <GroupsIcon style={{ marginRight: "12px" }} />
            Meus Usuários
          </Typography>
          <IconButton onClick={() => setOpenedModal(null)}>
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      {searching ? (
        <DialogContent>
          <LoadingData searching label="Buscando dados de usuários..." />
        </DialogContent>
      ) : (
        <DialogContent>
          <Scrollbar>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell align="center" style={{ padding: "0.5rem" }}>
                      Status
                    </TableCell>
                    <TableCell align="center" style={{ padding: "0.5rem" }}>
                      Cód Usuário
                    </TableCell>
                    <TableCell style={{ padding: "0.5rem" }}>Nome</TableCell>
                    <TableCell style={{ padding: "0.5rem" }}>Login</TableCell>
                    <TableCell align="center" style={{ padding: "0.5rem" }}>
                      Perfil
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {users.map((row) => {
                    const color = row.Ativo ? "success" : "error";
                    return (
                      <TableRow key={row.Id} hover>
                        <TableCell align="center" style={{ padding: "0.5rem" }}>
                          <CircleIcon color={color} />
                        </TableCell>
                        <TableCell align="center" style={{ padding: "0.5rem" }}>
                          {row.IdUsuario}
                        </TableCell>
                        <TableCell style={{ padding: "0.5rem" }}>
                          {row.Nome}
                        </TableCell>
                        <TableCell style={{ padding: "0.5rem" }}>
                          {row.Email}
                        </TableCell>
                        <TableCell align="center" style={{ padding: "0.5rem" }}>
                          {row.Perfis.map((p) => p.Nome).join(", ")}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Scrollbar>
        </DialogContent>
      )}

      <DialogActions>
        <Button
          variant="outlined"
          style={{ marginTop: "1.5rem" }}
          onClick={() => setOpenedModal(null)}
        >
          Fechar
        </Button>
        <Button
          variant="contained"
          color="primary"
          style={{ marginTop: "1.5rem" }}
          onClick={() => {
            setOpenedModal("ALTERACAO");
            setType("USERS");
          }}
        >
          Solicitar alteração
        </Button>
        {isAdmin && (
          <Button
            variant="contained"
            color="primary"
            style={{ marginTop: "1.5rem" }}
            onClick={() => history.push(`/admin/usuarios?action=create-user`)}
          >
            Novo usuário
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
